import { ListGroup, Col, Button } from "react-bootstrap";
import {
  CategoryFilter,
  PriceFilter,
  AttributeFilter,
  SortDropdown,
  RatingFilter,
} from "../filters";

export default function FilterMenu(props) {
  // side menu displaying filter/sorting options

  const sortOptions = [
    { value: "createdAt_-1", label: "Newest" },
    { value: "name_1", label: "Name: A-Z" },
    { value: "name_-1", label: "Name: Z-A" },
    { value: "price_1", label: "Price: Low To High" },
    { value: "price_-1", label: "Price: High To Low" },
    { value: "rating_-1", label: "Customer Rating" },
  ];

  return (
    <Col
      md={3}
      className={`filter-container ${
        props.menuCollapsed ? "filter-menu-collapsed" : ""
      }`}
    >
      <ListGroup variant="flush">
        {/* SEARCH BOX INPUT */}
        {props.selectedFilters?.searchText && (
          <ListGroup.Item
            style={{
              fontSize: "larger",
              fontWeight: "600",
              display: "flex",
              justifyContent: "space-between",
              paddingTop: "0",
              marginBottom: "8px",
            }}
          >
            <span>
              <span>Results For: </span>
              <span style={{ fontWeight: "normal" }}>
                {props.selectedFilters?.searchText}
              </span>
            </span>
            <i
              onClick={props.handleRemoveSearchText}
              className="bi bi-x-circle"
              style={{ fontSize: "medium" }}
            ></i>
          </ListGroup.Item>
        )}

        {/* SORT BY */}
        <ListGroup.Item style={{ paddingTop: "0" }}>
          <SortDropdown
            selectedSort={props.selectedFilters.sortKey}
            handleChangeSortKey={props.handleChangeSortKey}
            sortOptions={sortOptions}
          />
        </ListGroup.Item>

        {/* FILTER BY */} 
        <ListGroup.Item>
          <CategoryFilter
            categoryOptions={props.selectedFilters?.category?.children}
            handleSelectNewCategory={props.handleSelectNewCategory}
            handleReturnToParentCategory={props.handleReturnToParentCategory}
            showReturnButton={!props.selectedFilters?.category?.isRoot}
          />
        </ListGroup.Item>

        <ListGroup.Item>
          <PriceFilter
            selectedPrice={props.selectedFilters?.price || props?.defaultPrice}
            handleChangePrice={props.handleChangePrice}
            handleSubmitPrice={props.handleSubmitPrice}
            defaultPrice={props?.defaultPrice}
          />
        </ListGroup.Item>
        <ListGroup.Item>
        
          <RatingFilter
            handleChangeRating={props.handleChangeRating}
            selectedRatings={props.selectedFilters?.ratings || []}
          />
        </ListGroup.Item>
        <ListGroup.Item>
          {props?.availableAttributesSet?.length > 0 && (
              <AttributeFilter
                availableAttributesSet={props.availableAttributesSet || []}
                handleChangeAttributes={props.handleChangeSelectedAttributes}
                selectedAttributes={props.selectedFilters.selectedAttributes || []}
              />
            )}
        </ListGroup.Item>

        {/* BUTTONS */}
        <ListGroup.Item
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button
            className="mt-2"
            variant="outline-danger"
            onClick={props.handleResetAllFilters}
          >
            Reset All Filters
          </Button>
          <span
            onClick={() => props.setMenuCollapsed(true)}
            style={{ cursor: "pointer" }}
            className="mt-3 filter-menu-header"
          >
            {props.upArrow}
          </span>
        </ListGroup.Item>
      </ListGroup>
    </Col>
  );
}
